export const GET_YOUTH_ADVISORY_COUNCIL_SUCCESS =
  'GET_YOUTH_ADVISORY_COUNCIL_SUCCESS';
export const GET_YOUTH_ADVISORY_COUNCIL_FAILURE =
  'GET_YOUTH_ADVISORY_COUNCIL_FAILURE';

export const POST_YOUTH_ADVISORY_COUNCIL_SUCCESS =
  'POST_YOUTH_ADVISORY_COUNCIL_SUCCESS';
export const POST_YOUTH_ADVISORY_COUNCIL_FAILURE =
  'POST_YOUTH_ADVISORY_COUNCIL_FAILURE';
